const str = '';
const dateTimeString = new Date()?.toISOString();

export const roleDataModelGet = ({ id = '', }) => {
    return {
        id: id,
        isMaster: false,
        isAdmin: false,
        msgWarning: str,
        created: dateTimeString,
        description: str,
        userId: str,
    }
};